import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import { AnalyticsListener } from '@atlaskit/analytics-next';
import { FabricChannel } from '../types';
import { handleEvent } from './handle-event';
export const ELEMENTS_TAG = 'fabricElements';
export default class FabricElementsListener extends React.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "handleEventWrapper", event => {
      handleEvent(event, ELEMENTS_TAG, this.props.logger, this.props.client);
    });
  }

  render() {
    return /*#__PURE__*/React.createElement(AnalyticsListener, {
      onEvent: this.handleEventWrapper,
      channel: FabricChannel.elements
    }, this.props.children);
  }

}